export const styles = () => ({
  TemplateButton: {
    marginRight: '12px',
    marginBottom: '7px',
  },
  TemplateDropdown: {
    width: '350px',
    marginRight: '24px',
  },
});
